import { Navigate } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import { AdminLayout } from '../layout/AdminLayout'

export function ProtectedRoute() {
  const { user, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/admin/login" replace />
  }

  // Phase 8A-5 — authenticated admin pages render inside the shared
  // AdminLayout (sidebar navigation + nested Outlet). Auth behavior above
  // is unchanged; AdminLayout is only reachable under /admin/* routes.
  return <AdminLayout />
}